(function() {
  'use strict';

  var cfg = window.PRIVE_LIVE_SEARCH_CONFIG || {};
  var engineBase = cfg.engineBase || 'https://prive-engine.fly.dev';
  var customerId = String(cfg.customerId || '').trim();
  var authRefreshPromise = null;
  var authTtlSeconds = 240;

  function readMetaNode(root, name) {
    return root.querySelector('meta[name="' + name + '"]');
  }

  function readMeta(name) {
    var node = readMetaNode(document, name);
    return node ? String(node.getAttribute('content') || '').trim() : '';
  }

  function writeMeta(name, value) {
    var node = readMetaNode(document, name);
    if (!node) {
      node = document.createElement('meta');
      node.setAttribute('name', name);
      document.head.appendChild(node);
    }
    node.setAttribute('content', value);
  }

  function getAuthMeta(root) {
    var source = root || document;
    return {
      timestamp: readMetaNode(source, 'prive-live-search-ts') ? String(readMetaNode(source, 'prive-live-search-ts').getAttribute('content') || '').trim() : '',
      token: readMetaNode(source, 'prive-live-search-token') ? String(readMetaNode(source, 'prive-live-search-token').getAttribute('content') || '').trim() : '',
    };
  }

  function buildAuthHeaders(meta) {
    var authMeta = meta || getAuthMeta();
    if (!customerId || !authMeta.timestamp || !authMeta.token) return null;

    return {
      'Content-Type': 'application/json',
      'X-Prive-TS': authMeta.timestamp,
      'X-Prive-Token': authMeta.token,
      'X-Prive-Customer-Id': customerId,
    };
  }

  function isFreshTimestamp(timestamp) {
    var seconds = Number(timestamp);
    if (!Number.isFinite(seconds) || seconds <= 0) return false;
    return Math.abs(Math.floor(Date.now() / 1000) - seconds) < authTtlSeconds;
  }

  function buildRefreshUrl() {
    var url = new URL(window.location.href);
    url.searchParams.set('_prive_live_search_auth', String(Date.now()));
    return url.toString();
  }

  function refreshAuthMeta(originalFetch) {
    if (authRefreshPromise) return authRefreshPromise;

    authRefreshPromise = originalFetch(buildRefreshUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then(function(response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var parsed = parser.parseFromString(html, 'text/html');
        var refreshed = getAuthMeta(parsed);
        if (!refreshed.timestamp || !refreshed.token) return null;
        writeMeta('prive-live-search-ts', refreshed.timestamp);
        writeMeta('prive-live-search-token', refreshed.token);
        return refreshed;
      })
      .catch(function() {
        return null;
      })
      .finally(function() {
        authRefreshPromise = null;
      });

    return authRefreshPromise;
  }

  function ensureFreshAuthHeaders(originalFetch) {
    if (!customerId) return Promise.resolve(null);

    var current = getAuthMeta();
    if (current.timestamp && current.token && isFreshTimestamp(current.timestamp)) {
      return Promise.resolve(buildAuthHeaders(current));
    }

    return refreshAuthMeta(originalFetch).then(function(refreshed) {
      return buildAuthHeaders(refreshed);
    });
  }

  function isSimilarityRequest(url) {
    return /\/api\/similarity(?:\?|$)/.test(url || '');
  }

  function parseSimilarityBody(init) {
    if (!init || !init.body) return {};
    if (typeof init.body !== 'string') return {};

    try {
      return JSON.parse(init.body);
    } catch (error) {
      return null;
    }
  }

  function rewriteSimilarityRequest(input, init, originalFetch) {
    var body = parseSimilarityBody(init);
    if (body === null) {
      return Promise.resolve(new Response(JSON.stringify({ error: 'Invalid body' }), {
        status: 400,
        headers: { 'Content-Type': 'application/json' },
      }));
    }

    var handle = typeof body.handle === 'string' ? body.handle.trim() : '';
    if (!handle) {
      return Promise.resolve(new Response(JSON.stringify({ error: 'Missing handle' }), {
        status: 400,
        headers: { 'Content-Type': 'application/json' },
      }));
    }

    return ensureFreshAuthHeaders(originalFetch).then(function(headers) {
      if (!headers) {
        return new Response(JSON.stringify({ scores: [] }), {
          status: 200,
          headers: { 'Content-Type': 'application/json' },
        });
      }

      return originalFetch(engineBase + '/api/public/live-search/similarity', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ handle: handle, limit: 4 }),
        credentials: 'omit',
        mode: 'cors',
        signal: init && init.signal,
      });
    });
  }

  if (window.fetch && !window.__PRIVE_TRUSTED_SIMILARITY_PATCHED__) {
    var originalFetch = window.fetch.bind(window);
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (isSimilarityRequest(url)) {
        return rewriteSimilarityRequest(input, init || {}, originalFetch);
      }
      return originalFetch(input, init);
    };
    window.__PRIVE_TRUSTED_SIMILARITY_PATCHED__ = true;
  }
})();
